<template>
	<Dialog header="Approval Confirmation" :visible="visible" @update:visible="onVisibleChange"
		:breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '30vw' }" :modal="true">
		<div class="flex flex-column align-items-center gap-3" style="margin-top: 8px">
			<div class="flex align-items-center gap-3 border-round px-3 py-3 w-full flex-row"
				style="background: rgba(59, 130, 246, 0.08); color: #1d4ed8;">
				<i class="pi pi-question-circle" style="font-size: 1.5rem" />
				<div class="font-semibold ml-2">Confirmation required</div>
			</div>
			<div class="flex flex-column gap-4 w-full">
				<div class="flex align-items-start gap-3 border-round px-3 py-3 w-full mt-2"
					style="background: rgba(245, 158, 11, 0.12); color: #92400e;">
					<i class="pi pi-info-circle" style="font-size: 1.25rem" />
					<div style="line-height: 1.6">
						Approval will now be directed to
						<strong>snapx.dexagroup.com</strong>.
						Please ensure approvers can access SnapX to process this invoice.
					</div>
				</div>
				<p class="m-0" style="line-height: 1.6">
					Are you sure you want to submit this invoice for approval to the approver(s) below?
				</p>
				<div class="flex flex-column align-items-center gap-2">
					<template v-for="(approver, index) in approvers" :key="approver + index">
						<div class="surface-100 border-round px-3 py-3 text-center w-full">
							{{ approver }}
						</div>
						<i v-if="index < approvers.length - 1" class="pi pi-arrow-down"
							style="font-size: 1rem; margin: 0.35rem 0" />
					</template>
				</div>
				<div class="flex align-items-start gap-2 w-full mt-2">
					<Checkbox v-model="acknowledged" :binary="true" inputId="snapxRedirectAcknowledged" />
					<label for="snapxRedirectAcknowledged" class="ml-2" style="line-height: 1.6; cursor: pointer">
						I understand that approval will be directed to snapx.dexagroup.com
					</label>
				</div>
			</div>
		</div>
		<template #footer>
			<Button label="Cancel" icon="pi pi-times" @click="cancel" class="p-button-text" />
			<Button label="Confirm" icon="pi pi-check" @click="confirm" :disabled="!acknowledged" autofocus />
		</template>
	</Dialog>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
	visible: { type: Boolean, default: false },
	approvers: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:visible', 'confirm', 'cancel']);

const acknowledged = ref(false);

// every time the dialog is (re)opened the user must tick the checkbox again
watch(
	() => props.visible,
	() => {
		acknowledged.value = false;
	}
);

const cancel = () => {
	acknowledged.value = false;
	emit('update:visible', false);
	emit('cancel');
};

const confirm = () => {
	if (!acknowledged.value) {
		return;
	}

	acknowledged.value = false;
	emit('update:visible', false);
	emit('confirm');
};

// closing via the X / mask / Esc behaves like Cancel
const onVisibleChange = (value) => {
	if (!value) {
		cancel();
	}
};
</script>
